import { Container, Button, Form, Card, Alert } from "react-bootstrap";
import { motion } from "framer-motion";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const res = await axios.post("/api/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <Container
      style={{ height: "80vh" }}
      className="d-flex justify-content-center align-items-center"
    >
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
        <Card className="p-4 shadow-lg border-0" style={{ width: 400 }}>
          <h2 className="text-gradient text-center mb-3">Login</h2>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Control
              name="email"
              placeholder="Email"
              className="mb-3"
              required
            />
            <Form.Control
              name="password"
              type="password"
              placeholder="Password"
              className="mb-3"
              required
            />

            <Button
              type="submit"
              variant="primary"
              className="w-100 fw-bold mb-3"
            >
              Login
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              className="p-0"
              onClick={() => navigate("/register")}
            >
              Don’t have an account? Register!
            </Button>
          </div>
        </Card>
      </motion.div>
    </Container>
  );
}
